import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { pushRoute } from '../../utils'
import { resumeContactProcess } from '../../state/actions/stepActions'
import Collapse, { Panel } from 'rc-collapse'
import 'rc-collapse/assets/index.css'
import Button from '../../components/button'
import Clearfix from '../../components/clearfix'
import { connect } from 'react-redux'

import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'

class Requests extends Component {
  constructor(props) {
    super(props)
    this.state = { accordion: true, activeKey: [] }
    this.onChange = this.onChange.bind(this)
  }

  onChange(activeKey) {
    this.setState({ activeKey })
  }

  openReuploadView(guid) {
    const { routing } = this.props
    pushRoute(`/reupload/${routing.flow}/${guid}`)
  }

  resumeRequest(productName,guid) {
    const { dispatch,routing } = this.props
    if(!!productName)
    {
    routing.flow=productName
    }
    dispatch(resumeContactProcess(guid))
  }

  getStatus(product) {
    const cleanStatuses = {
      K: 'Documento respinto', // rejected document
      T: 'In attesa di apertura', // unknown document status
      A: 'Da completare',
      F: 'Da completare'
    }

    return !!cleanStatuses[product.statusCode]
      ? cleanStatuses[product.statusCode]
      : product.status
  }

  getDocumentStatus(contract) {
    if (!!contract && contract.sign === 'true') {
      return 'Doc. accettato'
    } else if (!!contract && contract.sign === 'false') {
      return 'Doc. respinto'
    } else {
      return 'Doc. da verificare'
    }
  }

  getItems() {
    const { requestList, contractList } = this.props

    if (!this.globalStylesOverrides) {
      this.globalStylesOverrides = css(this.props.styles.globals)
    }

    if (!!requestList && !!contractList) {
      return requestList.map((product, index) => {
        const contract = contractList.find(
          c => c.guid === product.guid && c.azioni === 'UPLOAD'
        )
        return (
          <Panel
            {...css(this.props.styles.detail)}
            showArrow={true}
            header={`${product.contactId} - ${this.getStatus(product)}`}
            key={index}
          >
            <div {...css(this.props.styles.listColumn)}>
              <div>
                <div {...css(this.props.styles.label)}> Prodotto </div>
                <div {...css(this.props.styles.value)}>{product.prodotto}</div>
              </div>
              <div>
                <div {...css(this.props.styles.label)}> Intestatario </div>
                <div {...css(this.props.styles.value)}>
                  {' '}
                  {product.nome} {product.cognome}{' '}
                </div>
              </div>
              <div>
                <div {...css(this.props.styles.label)}> Richiesta numero </div>
                <div {...css(this.props.styles.value)}>
                  {' '}
                  {product.contactId}{' '}
                </div>
              </div>
              <div>
                <div {...css(this.props.styles.label)}> Ultima modifica </div>
                <div {...css(this.props.styles.value)}>
                  {' '}
                  {product.lastEdit}{' '}
                </div>
              </div>
              {product.statusCode === 'A' || product.statusCode === 'F' ? (
                <div>
                  <div {...css(this.props.styles.label)}>
                    {' '}
                    Ti sei fermato allo step{' '}
                  </div>
                  <div {...css(this.props.styles.value)}>
                    {' '}
                    {product.lastStep}{' '}
                  </div>
                </div>
              ) : (
                ''
              )}
              {!!product.docType ? (
                <div>
                  <div {...css(this.props.styles.label)}> Tipo documento </div>
                  <div {...css(this.props.styles.value)}>
                    {' '}
                    {product.docType}{' '}
                  </div>
                </div>
              ) : (
                ''
              )}
              <div>
                <div {...css(this.props.styles.label)}> Esito documento </div>
                <div {...css(this.props.styles.value)}>
                  {this.getDocumentStatus(contract)}
                </div>
              </div>
            </div>
            <div
              {...css(
                this.props.styles.listColumn,
                this.props.styles.listColumnButtons
              )}
            >
              {product.statusCode === 'K' ? (
                <Button
                  text="Reinvia"
                  type="primaryEnabled"
                  value={product.guid}
                  pullTo="right"
                  action={this.openReuploadView.bind(this)}
                />
              ) : (
                ''
              )}
              {product.statusCode === 'A' || product.statusCode === 'F' ? (
                <Button
                  text="Riprendi"
                  type="primaryEnabled"
                  value={product.guid}
                  pullTo="right"
                  action={this.resumeRequest.bind(this,product.prodotto)}
                />
              ) : (
                ''
              )}
            </div>
            <Clearfix />
          </Panel>
        )
      })
    } else {
      return null
    }
  }

  render() {
    const accordion = this.state.accordion
    const activeKey = this.state.activeKey
    return (
      <Collapse
        accordion={accordion}
        onChange={this.onChange}
        activeKey={activeKey}
      >
        {this.getItems()}
      </Collapse>
    )
  }
}
Requests.propTypes = {
  requestList: PropTypes.array,
  contractList: PropTypes.array
}

const mapStateToProps = state => {
  return { ...state }
}

export default connect(mapStateToProps)(withStyles(Styles)(Requests))



// WEBPACK FOOTER //
// ./components/requests/index.js